(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignInternetVideoV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-internet-video-v1', context);

      formatter.once('eh-thewink-hp-redesign-internet-video').each(function () {
        var thisFormatter = $(this);
        // Embed video poster image - PC only
        var $flexVideo = thisFormatter.find('.flex-video');

        if (!site.client.isMobile && $('body').hasClass('device-pc')) {
          var $imgContainer = thisFormatter.find('.img-container');

          $imgContainer.once('img-container').on('click', function () {
            $flexVideo.css({ 'display': 'block' });
            $(this).css({
              'visibility': 'hidden',
              'height': '0'
            });

            // autoplay
            var placeholderHeight = thisFormatter.find('.img-container').find('img.article-img').height();
            var iframeTag = $flexVideo.find('iframe');

            if (iframeTag.length > 0) {
              // autoplay
              iframeTag.css({ 'height': placeholderHeight });
              var iframeSrc = iframeTag.attr('src');
              var autoplaySrc = iframeSrc + '&autoplay=1';

              iframeTag.attr('src', autoplaySrc);
            }
          });
        } // if

        // Hide video poster image on mobile if it exist
        if (site.client.isMobile && $('body').hasClass('device-mobile')) {
          var $imgContainer = thisFormatter.find('.img-container');

          if ($imgContainer.find('img.article-img').length) {
            $imgContainer.hide();
          }
        }

        // Lazyload
        site.util.lazyLoaded(thisFormatter);
      });
    }
  };
})(jQuery);
